import { render, staticRenderFns } from "./WxOutbound.vue?vue&type=template&id=6552cbc3&scoped=true&"
import script from "./WxOutbound.vue?vue&type=script&lang=js&"
export * from "./WxOutbound.vue?vue&type=script&lang=js&"
import style0 from "./WxOutbound.vue?vue&type=style&index=0&id=6552cbc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6552cbc3",
  null
  
)

export default component.exports